import script from "./CompanyDigitalSignDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyDigitalSignDrawer.vue?vue&type=script&setup=true&lang=js"

import "./CompanyDigitalSignDrawer.vue?vue&type=style&index=0&id=315d577e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-315d577e"]])

export default __exports__